// A color as a person types it, into the `#rrggbb` a team stores (SCENARIOS L2).
//
// The Edit team sheet's Custom fields. `TeamColors` is six hex digits and the
// server takes nothing else; this is only the forgiveness in front of it.

/**
 * A typed color as the `#rrggbb` a team stores, or null when it is not one yet.
 *
 * Forgiving about the spelling a person types — with or without the `#`, three
 * digits or six — and nothing else: `TeamColors` is six hex digits, so that is
 * what leaves the sheet.
 */
export function hexOf(raw: string): string | null {
  const m = /^#?([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/.exec(raw.trim());
  if (!m) return null;
  const digits = m[1]!;
  return `#${digits.length === 3 ? [...digits].map((c) => c + c).join('') : digits}`;
}
